import { useEffect, useState } from "react";
import MultiBranchSelect from "../../../../features/MultiBranchSelect";
import { useSelector } from "react-redux";
// import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { changeDataToYYYY_MMMM, getTodayMonth} from '../../../../utils/Date/SupportDate';
import { coverIDToFullName } from '../../../../utils/Branch/SupportBranch';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js';
import { Bar, Pie, Line  } from 'react-chartjs-2';
// import ChartDataLabels from "chartjs-plugin-datalabels";
import RoomReportTotalAreaBranchDetailsDay from "./RoomReportTotalAreaBranchDetailsDay";
// import RoomReportTotalDetailsRow2 from "./RoomReportTotalDetailsRow2";

function RoomReportTotalAreaBranch(props) {
    //const [typeViewAreaBranch, setTypeViewAreaBranch] = useState("Branch");
    const [dataBranch, setDataBranch] = useState({
        area: "Select Area",
        branch: "Select Branch",
        branchID: 0,
        month: getTodayMonth()
    });

    const auth = useSelector(state => state.auth);
    const allBranchInform = useSelector(state => state.allBranchInformation);
    const reportTotalRedux = useSelector(state => state.reportTotal);
    const { viewRoom } = reportTotalRedux;

    const { role, area, branchID } = auth.user;
    const isMultiBranch = (role === 5 || role === 6 || role === 7 || role === 8 || role === 1);
    const isMultiArea = (role === 7 || role === 1 || role === 8);

    const listArea = allBranchInform === undefined ? [] : Object.keys(allBranchInform);
   // var listBranch = renderListBranch(isMultiBranch ? dataBranch.area : auth.user.area)
    var listBranch = (role === 6) ? renderListBranch(area) : (role === 7) ? renderListBranch(dataBranch.area) : [];
    const percent = viewRoom.capacity;

    useEffect(() => {

    },[viewRoom.content])

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        ArcElement,
        BarElement,
        LineElement,
        //ChartDataLabels,
        Title,
        Tooltip,
        Legend
    );

    const optionsPie = {
        plugins: {
          title: {
                display: true,
                text: `OTA details (${viewRoom.OTATotal} nights)`,
                font: {
                    size: 20
                },
            },
          legend: {
            position: 'right',
            labels: {
              font: {
                size: 14,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
          // Plugin tùy chỉnh để hiển thị số liệu trực tiếp
          datalabels: {
            formatter: (value, context) => {
              const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
              const percentage = ((value / total) * 100).toFixed(1) + '%';
              return `${value}(${percentage})`; // Hiển thị cả giá trị và phần trăm
            },
            color: '#fff', // Màu chữ
            textAlign: 'center',
            font: {
              weight: 'bold',
              size: 12,
            },
          },
        },
       // maintainAspectRatio: true, // Bật để giữ tỷ lệ
        //aspectRatio: 1, // Tỷ lệ 1:1 để biểu đồ tròn
      //  responsive: true, // Đảm bảo biểu đồ phản hồi với kích thước container
      };

    const customDataLabelsPie = {
        id: 'customDataLabels',
        afterDatasetsDraw(chart) {
            const { ctx, data } = chart;
            chart.data.datasets.forEach((dataset, datasetIndex) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            meta.data.forEach((element, index) => {
                const { x, y } = element.tooltipPosition();
                const value = dataset.data[index];
                const total = dataset.data.reduce((sum, val) => sum + val, 0);
                const percentage = ((value / total) * 100).toFixed(1) + '%';
                const text = `${value}\n(${percentage})`; // (${percentage})

                ctx.save();
                ctx.fillStyle = '#fff'; // Màu chữ
                ctx.font = 'bold 12px Arial';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(text, x, y);
                ctx.restore();
            });
            });
        },
    };

    function branchUseOTA() {
        switch(dataBranch.branchID) {
            case 1: case 4: case 9:  return ["agoda", "trip.com", "hafh"];
            case 3: return ["expedia", "booking.com", "agoda"];
            case 13: return ["expedia", "booking.com", "agoda", "rakuten"];
            case 7: return ["expedia", "booking.com", "agoda", "rakuten", "hafh"];
            case 8: return ["expedia", "booking.com", "agoda"];
            case 11: return ["expedia", "agoda", "trip.com"];
            case 12: return ["expedia", "booking.com", "agoda"];
            case 15: return ["expedia", "booking.com", "agoda", "trip.com"];
            case 16: return ["expedia", "booking.com", "agoda"];
            default: return ["expedia", "booking.com", "agoda"];
        }
    }

    const dataPie = {
        labels: branchUseOTA(),
        datasets: [
          {
            label: 'User Distribution',
            data:  branchUseOTA().map(channel => viewRoom.OTATotalDetails[channel]), // Số liệu mẫu
            backgroundColor: [
              '#FF6384', // Email: Hồng
              '#36A2EB', // Google: Xanh dương
              '#FFCE56', // Apple: Vàng
              '#4BC0C0', // Line: Xanh lam
              '#9966FF', // Facebook: Tím
            ],
            hoverOffset: 20,
          },
        ],
      };

    const options = {
        cutout: "65%",
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: 'Capacity',
            },
            tooltip: {
                enabled: true,
              },
        },
    };

    const centerTextPlugin = {
        id: "centerText",
        beforeDraw: (chart) => {
          const { width, height, ctx } = chart;
          ctx.restore();
          const fontSize = (height / 100).toFixed(2);
          ctx.font = `${fontSize}em sans-serif`;
          ctx.textBaseline = "middle";
      
          const text = percent+"%";
          const textX = Math.round((width - ctx.measureText(text).width) / 2);
          const textY = height / 2;
      
          ctx.fillStyle = "#36A2EB";
          ctx.fillText(text, textX, textY);
          ctx.save();
        },
      };

    const shadowPlugin = {
    id: "shadowSlice",
    beforeDatasetDraw(chart, args, pluginOptions) {
        const { ctx } = chart;
        ctx.save();
        ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
        ctx.shadowBlur = 12;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 4;
    },
    afterDatasetDraw(chart, args, pluginOptions) {
        chart.ctx.restore();
    },
    };

    function renderListBranch(areaValue) {
        let list = [];
        if (JSON.stringify(allBranchInform) !== '{}' && areaValue !== "Select Area") {
            allBranchInform[areaValue].forEach(branch => {
                list.push(branch.name);
            })
        } else {
            list = []
        }
        return list;
    }

    function onChangeData(target, value, index) {
        const newData = {...dataBranch};

        if(target === "branch") {
            props.resetDataWithTarget("viewRoom", "REPORT BRANCH");
            const checkArea = isMultiArea ? dataBranch.area : isMultiBranch ? area : area// isMultiBranch ? area : isMultiArea ?  : area;
            newData.branchID  = allBranchInform[checkArea][index].branchID;
            newData[target] = value;
        } else if (target ==="month"){
            if(viewRoom.content.length > 0) props.resetDataWithTarget("viewRoom", "REPORT BRANCH")
            newData[target] = value;
        } else {
            newData[target] = value;
        }
        setDataBranch(newData);
    }

    function changeSelectArea(value, index) {onChangeData("area", value, index) }
    function changeSelectBranchID(value, index) {onChangeData("branch", value, index) }
    
    return (<div className="ml-3">
        {/* <ModalNotify closeModal={closeModal} /> */}
        <ul className="nav nav-sub row_freeze" id="test1">
            <MultiBranchSelect
                listArea={listArea}
                listBranch={listBranch}
                changeSelectArea={changeSelectArea}
                changeSelectBranchID={changeSelectBranchID}
                selectArea={dataBranch.area}
                selectBranch={dataBranch.branch}
            />

            <li className="nav-item-sub">
                <input
                    // disabled={Items.length > 0}
                    type="month"
                    className="nav-link-sub"
                    href="#"
                    onChange={e => onChangeData("month", e.target.value)}
                    value={dataBranch.month}
                />
            </li>

            <li className="rp__title ">
                <div
                    className="nav-item-sub btn_load_data"
                    id="modal_inputdata"
                    //nameBranchToBranchID()
                    //to={`/survey_online/${isMultiBranch ? dataBranch.branchID : branchID}/${dataBranch.month}`}
                    onClick={() => props.onLoadData(dataBranch.branchID, isMultiArea ? dataBranch.area.replace(/ /g, "_") : isMultiBranch ? area : area, dataBranch.month)}
                >
                    Load Data
                </div>
            </li>
        </ul>

        {viewRoom.content.length > 0 && <div>
            <div style={{background:'yellow',fontSize:'2.2rem', border:'1px solid', borderRadius: '25px', padding: '4px', fontWeight:'600'}}>
                <div>Azumaya {coverIDToFullName(dataBranch.branchID)} Branch Report Month</div>
                {/* <div>Room: 40</div> */}
            </div>
            <h1>Data Branch On Month</h1>
            {/* <h5 style={{color:'purple'}}>(Click to card can show details)</h5> */}
            <RoomReportTotalAreaBranchDetailsDay 
                roomTotal = {viewRoom.roomTotal}
                femaleTotal = { viewRoom.femaleTotal}
                data={viewRoom}
                percent = {viewRoom.percent}
                />

            <div style={{ width: '30%', background:'#f1d7db'}} className="d-flex">
                <Pie  options={{...optionsPie}} 
                    plugins={[customDataLabelsPie]}
                    data={dataPie} style={{width:"350px"}}/> 

             <div style={{background:'#d4f1f1', boder: '0.5px solid', width:'250%'}}>
                    <div className="d-flex">
                        <div style={{width:'200px'}}>
                            <Pie  options={options} 
                                plugins={[centerTextPlugin, shadowPlugin]}
                            data={{
                                    "labels": ["May",],
                                    "datasets": [
                                        {
                                            "label": "May",
                                            data: [viewRoom.percent, 100 - viewRoom.percent],
                                            backgroundColor: ["#36A2EB", "#E0E0E0"],
                                            hoverOffset: 4,
                                        },
                                    ]
                            }} /> 
                        </div>

                        <div style={{width:'600px'}}>
                            <Line  options={options} 
                                data={{
                                    labels: [
                                        "January", "February", "March", "April", "May", "June",
                                        "July", "August", "September", "October", "November", "December"
                                    ],
                                    datasets: [
                                        {
                                        label: `Capacity (%) - ${coverIDToFullName(dataBranch.branchID)} `,
                                        data: viewRoom.dataCapacityMonth,
                                        borderColor: "#36A2EB",
                                        backgroundColor: "#36A2EB",
                                        fill: false,
                                        tension: 0.3,
                                        pointRadius: 4,
                                        pointBackgroundColor: "#36A2EB",
                                        },
                                    ],
                                }} /> 
                        </div>
                    </div>
                </div>
            </div>

            <div style={{width:'100%', background:'#fff9ec'}}>
                <Bar  options={{...options,  
                                plugins: {
                                legend: {
                                    position: 'bottom',
                                },
                                title: {
                                    display: true,
                                    text: 'Area Capatity',
                                },
                                tooltip: {
                                    enabled: true,
                                },
                            },}} 
                            data={{
                                labels: [
                                    "January", "February", "March", "April", "May", "June",
                                    "July", "August", "September", "October", "November", "December"
                                ],
                                datasets: viewRoom.dataCapacityMonthArea,
                            }} 
                /> 
            </div>

            {/* <h1>Branch and area statistics</h1>
            <div className="report_total_row1 d-flex">
                <div style={{background:'#d4f1f1', boder: '0.5px solid', width:'50%'}}>
                    <div className="d-flex">
                        <div style={{width:'200px'}}>
                            <Pie  options={options} 
                                plugins={[centerTextPlugin, shadowPlugin]}
                            data={{
                                    "labels": ["May",],
                                    "datasets": [
                                        {
                                            "label": "May",
                                            data: [viewRoom.percent, 100 - viewRoom.percent],
                                            backgroundColor: ["#36A2EB", "#E0E0E0"],
                                            hoverOffset: 4,
                                        },
                                    ]
                            }} /> 
                        </div>

                        <div style={{width:'400px'}}>
                            <Line  options={options} 
                                data={{
                                    labels: [
                                        "January", "February", "March", "April", "May", "June",
                                        "July", "August", "September", "October", "November", "December"
                                    ],
                                    datasets: [
                                        {
                                        label: "Capacity (%) - CN Hà Nội",
                                        data: [55, 62, 68, 72, 78, 85, 90, 88, 83, 75, 68, 60],
                                        borderColor: "#36A2EB",
                                        backgroundColor: "#36A2EB",
                                        fill: false,
                                        tension: 0.3,
                                        pointRadius: 4,
                                        pointBackgroundColor: "#36A2EB",
                                        },
                                    ],
                                }} /> 
                        </div>
                    </div>

                    <div style={{width:'600px'}}>
                        <Bar  options={{...options,  
                                        plugins: {
                                        legend: {
                                            position: 'bottom',
                                        },
                                        title: {
                                            display: true,
                                            text: 'Area Capatity',
                                        },
                                        tooltip: {
                                            enabled: true,
                                        },
                                    },}} 
                                    data={{
                                        labels: [
                                            "January", "February", "March", "April", "May", "June",
                                            "July", "August", "September", "October", "November", "December"
                                        ],
                                        datasets: [
                                            {
                                            label: "TVL1",
                                            data:  [55, 60, 62, 68, 70, 75, 80, 78, 74, 70, 65, 60],
                                            backgroundColor: "#36A2EB",
                                            yAxisID: "y",
                                            },
                                            {
                                            label: "TVL2",
                                            data: [55, 60, 62, 68, 70, 75, 80, 78, 74, 70, 65, 60],
                                            backgroundColor: "#FF6384",
                                            yAxisID: "y",
                                            },
                                            {
                                                label: "LTT",
                                                data: [85, 10, 22, 88, 90, 75, 70, 28, 24, 20, 25, 40],
                                                backgroundColor: "yellow",
                                                yAxisID: "y",
                                            },
                                        ],
                                    }} 
                        /> 
                    </div>
                </div>

                <div style={{background:'lightgrey', boder: '0.5px solid', width:'50%'}} className="ml-2">
                    <div className="d-flex">
                        <div style={{width:'200px'}}>
                            <Pie  options={options} 
                                plugins={[centerTextPlugin, shadowPlugin]}
                            data={{
                                    "labels": ["May",],
                                    "datasets": [
                                        {
                                            "label": "May",
                                            data: [viewRoom.percent, 100 - viewRoom.percent],
                                            backgroundColor: ["#FF6384", "#E0E0E0"],
                                            hoverOffset: 4,
                                        },
                                    ]
                            }} /> 
                        </div>

                        <div style={{width:'400px'}}>
                            <Bar  options={options} 
                                data={{
                                    labels: [
                                        "January", "February", "March", "April", "May", "June",
                                        "July", "August", "September", "October", "November", "December"
                                    ],
                                    datasets: [
                                        {
                                            label: "Sale (Milion)",
                                            data: [55, 60, 62, 68, 70, 75, 80, 78, 74, 70, 65, 60],
                                            borderColor: "#FF6384",
                                            backgroundColor: "#FF6384",
                                            fill: false,
                                            tension: 0.3,
                                            pointRadius: 4,
                                            pointBackgroundColor: "#FF6384",
                                        },
                                    ]
                                }} /> 
                        </div>
                    </div>

                    <div style={{width:'600px'}}>
                        <Bar  options={{options,  plugins: {
                                        legend: {
                                            position: 'bottom',
                                        },
                                        title: {
                                            display: true,
                                            text: 'Area Capatity',
                                        },
                                        tooltip: {
                                            enabled: true,
                                        },
                                    },}} 
                                    data={{
                                        labels: [
                                            "January", "February", "March", "April", "May", "June",
                                            "July", "August", "September", "October", "November", "December"
                                        ],
                                        datasets: [
                                            {
                                            label: "TVL1",
                                            data:  [55, 60, 62, 68, 70, 75, 80, 78, 74, 70, 65, 60],
                                            backgroundColor: "#36A2EB",
                                            yAxisID: "y",
                                            },
                                            {
                                            label: "TVL2",
                                            data: [55, 60, 62, 68, 70, 75, 80, 78, 74, 70, 65, 60],
                                            backgroundColor: "#FF6384",
                                            yAxisID: "y",
                                            },
                                            {
                                                label: "LTT",
                                                data: [85, 10, 22, 88, 90, 75, 70, 28, 24, 20, 25, 40],
                                                backgroundColor: "yellow",
                                                yAxisID: "y",
                                            },
                                        ],
                                    }} 
                        /> 
                    </div>
                </div>
            </div> */}
        </div>
         }
    </div>)
}

export default RoomReportTotalAreaBranch;
